import { render } from "./ActiveDialog.vue?vue&type=template&id=b67112fe"
import script from "./ActiveDialog.vue?vue&type=script&lang=js"
export * from "./ActiveDialog.vue?vue&type=script&lang=js"

import "./ActiveDialog.vue?vue&type=style&index=0&id=b67112fe&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__